module.exports = __webpack_public_path__ + "img/cv.20a8cfff.svg";